import { fetcher } from "@website/fetcher/fetcher";
import { NextRouter } from "next/router";
import { WithdrawRequestParametersTypes, WithdrawResponseTypes } from "./types";

export const getWithdrawRequestApiURL = `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/wallet/v1/cashouts`;

export const GetWithdrawRequestsService = (
  { page, pageSize }: WithdrawRequestParametersTypes,
  router: NextRouter
): Promise<WithdrawResponseTypes> =>
  fetcher(
    {
      url: getWithdrawRequestApiURL,
      method: "GET",
      params: { page, pageSize }
    },
    router
  ).then(({ data }) => data);
